/* eslint-disable react/jsx-key */
import React from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import './top-bar-action-entity-icons.scss';
import { downloadCSVFromURL } from '@actions/data-table-actions';
import ExportButton from '@shared/export-button';
import { BASE_URL } from '@constants/endpoints';

const TopBarActionGroupIcons = () => {
  const dispatch = useDispatch();

  const { groupType, id } = useParams();

  const exportCSV = () => {
    const url = `${BASE_URL}/be/group/export_csv/${id}/`;
    const filename = `group-${groupType}-${id}-export.csv`;
    dispatch(downloadCSVFromURL(url, filename, 'group'));
  };

  if (id) {
    return [
      <ExportButton onClick={exportCSV} />
    ];
  }
  return null;
};

export default TopBarActionGroupIcons;
